import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { AccordionContext, ACCORDION_TYPE } from '../Accordion';
import styles from '@dtsl/css-accordion/dist/index.module.css';
function AccordionItem(props) {
  const {
    children,
    isOpen = false,
    onClick = () => {},
    index: itemIdx
  } = props;
  const {
    visibleAccordionItems,
    setVisibleAccordionItems,
    accordionType
  } = useContext(AccordionContext);
  const accordionItemClasses = classNames({
    [styles['sib-accordion__item']]: true,
    [styles['sib-accordion__item--expanded']]: visibleAccordionItems[itemIdx]
  });
  useEffect(() => {
    if (visibleAccordionItems[itemIdx] !== isOpen) {
      switch (accordionType) {
        case ACCORDION_TYPE.SINGLE_OPENABLE:
          setVisibleAccordionItems(prevState => {
            const newVisibilityOfAccordions = prevState.map((_, index) => index === itemIdx ? isOpen : false);
            return newVisibilityOfAccordions;
          });
          break;
        case ACCORDION_TYPE.MULTI_OPENABLE:
          setVisibleAccordionItems(prevState => {
            const newVisibilityOfAccordions = [...prevState];
            newVisibilityOfAccordions[itemIdx] = isOpen;
            return newVisibilityOfAccordions;
          });
          break;
      }
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement("li", {
    className: accordionItemClasses
  }, React.Children.map(children, (child, index) => {
    return /*#__PURE__*/React.cloneElement(child, {
      key: index,
      onClick,
      itemIdx
    });
  }));
}
AccordionItem.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  index: PropTypes.number
};
export default AccordionItem;